import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const inputCls = "w-full px-4 py-3.5 rounded-xl bg-white/10 border border-white/20 text-white placeholder-slate-400 text-base focus:outline-none focus:ring-2 focus:ring-[#C5A059]";

export default function CadastroAfiliado() {
  const [searchParams] = useSearchParams();
  const partnerRef = searchParams.get('parceiro') || '';
  const [partnerName, setPartnerName] = useState(null);
  const [form, setForm] = useState({ name: '', whatsapp: '', email: '', cpf_cnpj: '', pix_key: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(null);
  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  useEffect(() => {
    if (partnerRef) {
      axios.get(`${API}/partner-info/${partnerRef}`).then(r => setPartnerName(r.data.name)).catch(() => {});
    }
  }, [partnerRef]);

  const submit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const r = await axios.post(`${API}/affiliate-signup`, { ...form, partner_ref: partnerRef });
      setDone(r.data);
    } catch (err) {
      setError(err.response?.data?.detail || 'Erro ao cadastrar. Tente novamente.');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#0A2647] flex flex-col items-center p-5 py-10" data-testid="cadastro-afiliado-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-6">
          <p className="text-4xl mb-2">⭐</p>
          <h1 className="text-3xl font-bold text-[#C5A059]">Vire um Afiliado Oficial</h1>
          <p className="text-slate-300 text-sm mt-2">Falo com o Dono · Ganhe comissão por cada cliente</p>
          {partnerName && (
            <p className="mt-3 inline-block bg-[#C5A059]/15 border border-[#C5A059]/40 text-[#C5A059] text-xs font-semibold px-4 py-1.5 rounded-full" data-testid="afiliado-partner-badge">
              🤝 Convite de {partnerName}
            </p>
          )}
        </div>

        {!done ? (
          <>
            <div className="bg-white/10 border border-[#C5A059]/40 rounded-2xl p-5 mb-5 space-y-2">
              {[
                ['💰', <span key="1"><b className="text-white">Comissão na sua chave PIX</b> por cada cliente que fechar</span>],
                ['🔗', <span key="2">Seu <b className="text-white">Link Relâmpago</b>: o cliente preenche 3 campos e a venda é sua</span>],
                ['🛟', <span key="3">Cliente parou no meio? Nosso <b className="text-white">robô resgata o lead</b> por você</span>],
                ['🆓', <span key="4"><b className="text-white">Sem mensalidade</b> — aprovação na hora, kit completo no WhatsApp</span>],
              ].map(([icon, text], i) => (
                <p key={i} className="text-xs text-slate-300 leading-relaxed flex gap-2"><span>{icon}</span><span>{text}</span></p>
              ))}
            </div>

            <form onSubmit={submit} className="space-y-3" data-testid="afiliado-form">
              <input required placeholder="Seu nome completo" value={form.name} onChange={set('name')} className={inputCls} data-testid="afiliado-nome" />
              <input required placeholder="Seu WhatsApp (com DDD)" inputMode="tel" value={form.whatsapp} onChange={set('whatsapp')} className={inputCls} data-testid="afiliado-whatsapp" />
              <input required type="email" placeholder="Seu e-mail" value={form.email} onChange={set('email')} className={inputCls} data-testid="afiliado-email" />
              <input required placeholder="Seu CPF (para receber comissões)" inputMode="numeric" value={form.cpf_cnpj} onChange={set('cpf_cnpj')} className={inputCls} data-testid="afiliado-cpf" />
              <input required placeholder="Sua chave PIX" value={form.pix_key} onChange={set('pix_key')} className={inputCls} data-testid="afiliado-pix" />
              {error && <p className="text-red-400 text-sm text-center" data-testid="afiliado-error">{error}</p>}
              <button type="submit" disabled={loading} data-testid="afiliado-submit"
                className="w-full bg-[#C5A059] text-[#0A2647] font-bold text-lg py-4 rounded-xl hover:bg-[#b8934d] transition-colors disabled:opacity-60">
                {loading ? 'Ativando seu cadastro...' : 'Quero começar a vender 🚀'}
              </button>
              <p className="text-slate-400 text-xs text-center">Sua senha de acesso e o passo a passo chegam no seu WhatsApp</p>
            </form>
          </>
        ) : (
          <div className="bg-white/10 border border-[#C5A059]/40 rounded-2xl p-8 text-center" data-testid="afiliado-success">
            <p className="text-5xl mb-4">🎉</p>
            <h2 className="text-xl font-bold text-white mb-2">Cadastro aprovado!</h2>
            <p className="text-slate-300 text-sm leading-relaxed mb-3">
              Sua <b className="text-[#C5A059]">senha</b> e o <b className="text-[#C5A059]">kit de vendas</b> chegaram no seu WhatsApp.
            </p>
            <div className="bg-white/5 border border-white/15 rounded-xl p-3 mb-4">
              <p className="text-[10px] text-slate-400 uppercase tracking-wide mb-1">Seu Link Relâmpago (já pode divulgar!)</p>
              <p className="text-xs font-mono text-[#C5A059] break-all" data-testid="afiliado-quick-link">{done.quick_link}</p>
            </div>
            <a href="/afiliados/login" data-testid="afiliado-login-link"
              className="inline-block bg-[#C5A059] text-[#0A2647] font-bold px-6 py-3 rounded-xl">Entrar no meu painel</a>
          </div>
        )}
      </div>
    </div>
  );
}
